import store from '../../../common/state/store';
import bookmarkMenuStoreFactory from './modules/bookmarkMenuStoreFactory';
import configureSidebarInterfaceStoreFactory from './modules/configureSidebarInterfaceStoreFactory';
import bookmarkLinkBuilderInterfaceStoreFactory from './modules/bookmarkLinkBuilderInterfaceStoreFactory';
import folderLookupStoreFactory from './modules/folderLookupStoreFactory';

export default class StoreFactory {
  static registerModules () {
    store.registerModule('bookmarkMenuStore', bookmarkMenuStoreFactory())
    store.registerModule('configureSidebarInterfaceStore', configureSidebarInterfaceStoreFactory())
    store.registerModule('bookmarkLinkBuilderInterfaceStore', bookmarkLinkBuilderInterfaceStoreFactory())
    store.registerModule('folderLookupStore', folderLookupStoreFactory())
  }
}
